import CryptoJS from "crypto-js"; // must match backend ENV_SECRET_KEY

export function decryptEnv(encrypted, SECRET_KEY) {
  const key = CryptoJS.SHA256(SECRET_KEY);
  const iv = CryptoJS.enc.Hex.parse(encrypted.iv);
  const decrypted = CryptoJS.AES.decrypt(
    {
      ciphertext: CryptoJS.enc.Hex.parse(encrypted.content),
    },
    key,
    { iv }
  );

  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}
